/**
 * Module to add functions that evaluates the Quest object
 */
import {
  ILoyaltyQuestCompletion,
  LoyaltyQuestStatus,
  LoyaltyQuestStepStatus,
} from 'generated/graphql-gateway';

export const isQuestCompleted = (questStatus: LoyaltyQuestStatus | undefined) =>
  questStatus === LoyaltyQuestStatus.COMPLETED;
export const isQuestActivated = (questStatus: LoyaltyQuestStatus | undefined) =>
  questStatus === LoyaltyQuestStatus.ACTIVATED;
export const canActivateQuest = (questStatus: LoyaltyQuestStatus | undefined) =>
  questStatus === LoyaltyQuestStatus.NOT_ENROLLED;
export const isStepCompleted = (status: LoyaltyQuestStepStatus | undefined) =>
  status === LoyaltyQuestStepStatus.COMPLETED;
export const isIncentiveRedeemed = (lastCompletion: ILoyaltyQuestCompletion | undefined | null) =>
  !!lastCompletion?.redeemed;
